import type { Schema } from '@cli-types/core-engine/schema.js'
import { flattenFields } from '@core-engine/schema/field-helpers/flattening/flatten-fields.js'
import { isEntitySlugField } from './is-entity-slug-field.js'
import { isStringLikeSlugField } from './is-string-like-slug-field.js'

export function collectInvalidEntitySlugErrors(schema: Schema, errors: string[]): void {
  for (const field of flattenFields(schema.fields || [])) {
    if (!isEntitySlugField(field)) continue
    if (!isStringLikeSlugField(field)) {
      errors.push(
        `Entity schema "${schema.name}" declares slug as "${field.type}", but built-in Entity slugs must use "string", "varchar", or "text".`
      )
    }
  }
}
